import { createSlot } from "lib/@components/slot/create-slot"

export const MappingActions = createSlot("CobieActions")
